exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".floating-banner[data-v-06860edb]{position:fixed;width:100%;bottom:0;left:0;z-index:1000}.fb-enter-active[data-v-06860edb],.fb-leave-active[data-v-06860edb]{-webkit-transition:all .2s ease-out 0s;transition:all .2s ease-out 0s}.fb-enter[data-v-06860edb],.fb-leave-to[data-v-06860edb]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.fb-enter-to[data-v-06860edb],.fb-leave[data-v-06860edb]{opacity:1;-webkit-transform:translate(0);transform:translate(0)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06860edb","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/recommend/lp/partials/FloatingBannerBase.vue
// module id = kpVA
// module chunks = 0 2